/*
    Слайдеры
*/

class Slider {
    constructor(slider) {
        this.$slider = $(slider);
        this.$container = this.$slider.closest('.js-slider-wrap');

        this.init();
        this.bindMouse();
        this.bindClick();
    }



    init() {
        // Инициализация слайдера
        this.swiper = new Swiper(this.$slider, {
            loop: true,
            slidesPerView: 1,
            lazy: {
                loadPrevNext: true,
                loadPrevNextAmount: 1
            },
            navigation: {
                nextEl: this.$container.find('.js-slider-next'),
                prevEl: this.$container.find('.js-slider-prev')
            },
            pagination: {
                'el': this.$container.find('.js-slider-pagination'),
                'type': 'fraction',
                'formatFractionCurrent': (number) => {
                    if (number < 10) {
                        return '0' + number;
                    } else {
                        return number;
                    }
                },
                'formatFractionTotal': (number) => {
                    if (number < 10) {
                        return '0' + number;
                    } else {
                        return number;
                    }
                }
            },
            threshold: 10,
            roundLengths: true,
            speed: 700,
            a11y: true,
            grabCursor: false,
            simulateTouch: false
        });
    }



    // Курсор-стрелки
    bindMouse() {
        if (App.mobile) {
            return;
        }

        let containerW;
        let containerX;

        this.$container
            .on('mouseenter', () => {
                // кэшируем ширину и позицию слайдера
                containerX = this.$container.offset().left;
                containerW = this.$container.width();
            })
            .on('mousemove', (e) => {
                const x = e.pageX;

                // Курсор в левой и правой половине — разный
                if (x - containerX < containerW / 2) {
                    this.$slider.addClass('_left');
                } else {
                    this.$slider.removeClass('_left');
                }
            });
    }


    // Переключение кликом
    bindClick() {
        if (App.mobile) {
            return;
        }

        this.$container.on('click', (e) => {
            const containerX = this.$container.offset().left;
            const containerW = this.$container.width();
            const x = e.pageX;

            // В зависимости от того, в какой половине произошёл клик,
            // переключаем влево или вправо
            if (x - containerX < containerW / 2) {
                this.swiper.slidePrev();
            } else {
                this.swiper.slideNext();
            }
        });
    }
}



App.H.find('.js-slider').each(function() {
    new Slider(this);
});



// WEBPACK FOOTER //
// ./_src/js/modules/Slider.js